import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import SorteioApp from './sorteio/Sorteio'
import FormsApp from './forms/Forms'
import EmbaixadoresApp from './embaixadores/Embaixadores'

/**
 * Roteamento minimalista por pathname.
 * `/sorteio*`      → LP de sorteio do evento Diana
 * `/forms*`        → LP de captura de leads
 * `/embaixadores*` → LP de inscrição no programa Embaixador TFY
 * Qualquer outro   → LP comercial.
 */
const path = window.location.pathname
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

let page: React.ReactNode
if (path.startsWith('/sorteio')) page = <SorteioApp />
else if (path.startsWith('/forms')) page = <FormsApp />
else if (path.startsWith('/embaixadores')) page = <EmbaixadoresApp />
else page = <App />

root.render(<React.StrictMode>{page}</React.StrictMode>)
